import React, { useEffect, useState } from 'react'
import classes from "./FantasyGame.module.css"
import { useLocation, useNavigate } from 'react-router-dom'
import { fantasyGameLeaderboardApi, matchDetailsApi, userFantasyTeamApi } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
import Layout from '../component/Layout';
import SubLayout from '../component/SubLayout';
import moment from "moment-timezone";
import { FaArrowLeft, FaCircle, FaMinus } from 'react-icons/fa6';
import Container from '../component/Container';
import MyTeam from '../component/MyTeam';
import MatchEvents from '../component/MatchEvents';
import { toast } from 'react-toastify';
import SmallLoader from '../component/SmallLoader';
import { removeUserDetails } from '../store/slices/userSlice';
import PlayerStatsModal from '../component/PlayerPointsModal';
import { useTranslation } from 'react-i18next';

const FantasyGame = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [matchDetails, setMatchDetails] = useState(null);
    const [matchDetails2, setMatchDetails2] = useState(null);
    const [team, setTeam] = useState(null);
    const [tab, setTab] = useState("myteam");

    const [leaderboard, setLeaderboard] = useState([]);
    const [userRank, setUserRank] = useState(null);

    const { userDetails } = useSelector(state => state?.persisted?.userSlice);

    const { playerPointsModal, playerId, matchFixtureId } = useSelector(state => state?.playerPointsModalSlice);

    const [time, setTime] = useState(null);
    const [display, setDisplay] = useState("block");

    const [loading, setLoading] = useState(true);
    const [loader, setLoader] = useState(true);

    const [leaderboardLoading, setLeaderboardLoading] = useState(true);

    const [userTeamLoading, setUserTeamLoading] = useState(true);

    const dispatch = useDispatch();

    const {t}=useTranslation();

    const fetchMatchDetails = async (load) => {
        try {

            if (load) {
                setLoading(true);
            }

            setLoader(true);
            const response = await matchDetailsApi(location?.state?.match_fixture_id, userDetails?.token);
            console.log(response, 'response...');
            setMatchDetails(response?.data);
            if (response?.data?.match_details) {
                setMatchDetails2(JSON.parse(response?.data?.match_details));
            }
            setLoading(false);
            setLoader(false);

        } catch (error) {
            if (error?.response?.status == 403) {
                dispatch(removeUserDetails());
                toast.error(t("129"));
                navigate('/');
            }
            else {
                setLoading(false);
                setLoader(false);
                toast.error(error?.response?.data?.message || error?.response?.message || error?.data?.message || t("128"));
                console.log(error, 'error---');
            }
        }
    }

    console.log(team, 'team..');
    console.log(matchDetails, 'md');

    const fetchUserTeam = async (load) => {
        try {
            if (load) {
                setUserTeamLoading(true);
            }
            setLoader(true);
            const response = await userFantasyTeamApi(location?.state?.match_fixture_id, userDetails?.token);
            console.log(response, 'response..');
            setTeam(JSON.parse(response?.data?.team));
            setLoader(false);
            setUserTeamLoading(false);

        } catch (error) {
            setLoader(false);
            setUserTeamLoading(false);
            toast.error(error?.response?.data?.message || error?.response?.message || error?.data?.message || t("128"));
            console.log(error, 'error---0');
        }
    }

    const fetchMatchLeaderboard = async (load) => {
        try {
            if (load) {
                setLeaderboardLoading(true);
            }
            setLoader(true);
            const response = await fantasyGameLeaderboardApi(location?.state?.match_fixture_id, userDetails?.token);
            setLeaderboard(response?.data?.leaderboard);
            setUserRank(response?.data?.userRank?.[0]);

            setLeaderboardLoading(false);
            setLoader(false);
        } catch (error) {

            setLeaderboardLoading(false);
            setLoader(false);
            toast.error(error?.response?.data?.message || error?.response?.message || error?.data?.message || t("128"));

            console.log(error, 'error---');
        }
    }

    console.log({ leaderboard, userRank }, 'rank...');

    useEffect(() => {
        if (location?.state?.match_fixture_id) {
            fetchMatchDetails(true);
            fetchUserTeam(true);
            fetchMatchLeaderboard(true);
        }
        else {
            navigate("/home");
        }
    }, [location?.state?.match_fixture_id]);

    const matchTimer = (match_date_time) => {
        try {
            const liveTime = moment();
            const matchTime = moment.utc(match_date_time);
            const timeLeft = moment.duration(matchTime.diff(liveTime));

            if (timeLeft.asMilliseconds() <= 0) {
                console.log("Match has already started.");
                setDisplay("none");
            }
            const hours = Math.floor(timeLeft.asHours());
            const minutes = timeLeft.minutes();
            const seconds = timeLeft.seconds();

            console.log(`Match starts in ${hours}h ${minutes}m ${seconds}s`);
            // return `${hours}h ${minutes}m ${seconds}s`;
            setTime(`${hours}h ${minutes}m ${seconds}s`);
            // setExpireTime(`${hours}h ${minutes}m ${seconds}s`)
        } catch (error) {
            console.log(error, 'errro--');
        }
    }

    useEffect(() => {
        if (matchDetails?.match_status == "NS" && display != "none") {
            const intervalId = setInterval(() => {
                matchTimer(matchDetails?.match_date_time);
            }, 1000);

            return () => {
                clearInterval(intervalId);
            }
        }
    }, [matchDetails, display]);


    useEffect(() => {
        if (!loader && location?.state?.match_fixture_id) {
            const intervalId = setInterval(() => {
                if (!document.hidden) {
                    fetchMatchDetails();
                    fetchUserTeam();
                    fetchMatchLeaderboard();
                }
            }, 10000);
            return () => clearInterval(intervalId);
        }

    }, [loader, location?.state?.match_fixture_id]);

    return (
        <Layout>

            <SubLayout>
                <div className={classes.header}>
                    <div className={classes.header_nav}>
                        <div className={classes.header_nav_container}>
                            <button type='button' className={classes.back_button}>
                                <FaArrowLeft className={classes.back_icon} onClick={() => navigate("/home")} />
                            </button>
                        </div>
                    </div>

                    {loading ? <SmallLoader /> : (
                        <>
                            <div className={classes.match_details_container}>

                                {
                                    // matchDetails?.match_status == "NS" ? (
                                    //     <div className={classes.match_status}>
                                    //         <p className={classes.status_text}>Not Started Yet</p>
                                    //     </div>
                                    // ) :
                                    matchDetails?.match_status == "FT" ? (
                                        <div className={classes.match_status}>
                                            <p className={classes.status_text}>{t("56")}</p>
                                        </div>
                                    ) :
                                        matchDetails?.match_status == "AET" ? (
                                            <div className={classes.match_status}>
                                                <p className={classes.status_text}>{t("56")}</p>
                                            </div>
                                        ) : matchDetails?.match_status == "PEN" ? (
                                            <div className={classes.match_status}>
                                                <p className={classes.status_text}>{t("56")}</p>
                                            </div>
                                        ) : matchDetails?.match_status == "SUSP" ? (
                                            <div className={classes.match_status}>
                                                <p className={classes.status_text}>{t("57")}</p>
                                            </div>
                                        ) :
                                            matchDetails?.match_status == "PST" ? (
                                                <div className={classes.match_status}>
                                                    <p className={classes.status_text}>{t("58")}</p>
                                                </div>
                                            ) :
                                                matchDetails?.match_status == "CANC" ? (
                                                    <div className={classes.match_status}>
                                                        <p className={classes.status_text}>{t("59")}</p>
                                                    </div>
                                                ) :
                                                    matchDetails?.match_status == "ABD" ? (
                                                        <div className={classes.match_status}>
                                                            <p className={classes.status_text}>{t("60")}</p>
                                                        </div>
                                                    ) :
                                                        (matchDetails?.match_status == "AWD" || matchDetails?.match_status == "WO") ? (
                                                            <div className={classes.match_status}>
                                                                <p className={classes.status_text}>{t("60")}</p>
                                                            </div>
                                                        ) :
                                                            (matchDetails?.match_status == "1H" || matchDetails?.status == "LIVE") ?
                                                                (
                                                                    <div className={classes.match_status}>
                                                                        <p className={classes.status_text}>
                                                                            <FaCircle className={`${classes.text_danger_glow} ${classes.blink}`}
                                                                                style={{ fontSize: "8px" }}
                                                                            />
                                                                            <span style={{ marginLeft: "6px" }}>
                                                                                <>{matchDetails2?.fixture?.status?.elapsed}`</>
                                                                            </span>
                                                                        </p>
                                                                    </div>
                                                                ) :
                                                                matchDetails?.match_status == "HT" ?
                                                                    (
                                                                        <div className={classes.match_status}>
                                                                            <p className={classes.status_text}>
                                                                                <FaCircle className={`${classes.text_danger_glow} ${classes.blink}`}
                                                                                    style={{ fontSize: "8px" }}
                                                                                />
                                                                                <span style={{ marginLeft: "6px" }}>
                                                                                    {t("61")}{" "}<>{matchDetails2?.fixture?.status?.elapsed}`</>
                                                                                </span>
                                                                            </p>
                                                                        </div>
                                                                    ) : matchDetails?.match_status == "2H" ?
                                                                        (
                                                                            <div className={classes.match_status}>
                                                                                <p className={classes.status_text}>
                                                                                    <FaCircle className={`${classes.text_danger_glow} ${classes.blink}`}
                                                                                        style={{ fontSize: "8px" }}
                                                                                    />
                                                                                    <span style={{ marginLeft: "6px" }}>
                                                                                        <>{matchDetails2?.fixture?.status?.elapsed}`</>
                                                                                    </span>
                                                                                </p>
                                                                            </div>
                                                                        ) : matchDetails?.match_status == "ET" ?
                                                                            (
                                                                                <div className={classes.match_status}>
                                                                                    <p className={classes.status_text}>
                                                                                        <FaCircle className={`${classes.text_danger_glow} ${classes.blink}`}
                                                                                            style={{ fontSize: "8px" }}
                                                                                        />
                                                                                        <span style={{ marginLeft: "6px" }}>
                                                                                            <>{matchDetails2?.fixture?.status?.elapsed}`</>{" "} {t("62")} {matchDetails2?.fixture?.status?.extra}`
                                                                                        </span>
                                                                                    </p>
                                                                                </div>
                                                                            ) : matchDetails?.match_status == "P" ?
                                                                                (
                                                                                    <div className={classes.match_status}>
                                                                                        <p className={classes.status_text}>
                                                                                            <FaCircle className={`${classes.text_danger_glow} ${classes.blink}`}
                                                                                                style={{ fontSize: "8px" }}
                                                                                            />
                                                                                            <span style={{ marginLeft: "6px" }}>
                                                                                                {t("63")}{" "}<>{matchDetails2?.fixture?.status?.elapsed}`</>
                                                                                            </span>
                                                                                        </p>
                                                                                    </div>
                                                                                ) : null}

                                <div className={classes.match_details}>
                                    <div className={classes.team}>
                                        <img src={matchDetails?.home_team_image} alt={matchDetails?.home_team_name} className={classes.team_logo} />
                                        <p className={classes.team_name}>{matchDetails?.home_team_name}</p>
                                    </div>
                                    <div className={classes.score_container}>
                                        <p className={classes.score}>
                                            {matchDetails2?.goals?.home}
                                        </p>
                                        <div className={classes.separator}>
                                            <FaMinus className={classes.separator_icon} />
                                        </div>
                                        <p className={classes.score}>
                                            {matchDetails2?.goals?.away}
                                        </p>
                                    </div>
                                    <div className={classes.team}>
                                        <img src={matchDetails?.away_team_image} alt={matchDetails?.away_team_name} className={classes.team_logo} />
                                        <p className={classes.team_name}>{matchDetails?.away_team_name}</p>
                                    </div>
                                </div>

                                {matchDetails?.match_status == "NS" &&
                                    <div className={classes.match_timer_container} style={{display}}>
                                        <p className={classes.match_timer}>
                                            {time}
                                        </p>
                                    </div>
                                }

                                <p className={classes.match_time} style={{ paddingTop: "10px" }}>
                                    {moment.utc(matchDetails?.match_date_time).local().format("dddd, DD MMM YYYY [at] hh:mm A")}
                                </p>
                            </div>
                        </>
                    )}

                    <div className={classes.tabs_container}>
                        <button type='button' className={`${classes.tab_option} ${tab === "myteam" && classes.active}`}
                            onClick={() => setTab("myteam")}
                        >
                            {t("64")}
                        </button>
                        <button type="button" className={`${classes.tab_option} ${tab === "leaderboard" && classes.active}`}
                            onClick={() => setTab("leaderboard")}

                        >
                            {t("65")}
                        </button>
                        <button type="button" className={`${classes.tab_option} ${tab === "events" && classes.active}`}
                            onClick={() => setTab("events")}

                        >
                            {t("66")}
                        </button>
                    </div>
                </div>

                <Container style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                    {tab === "myteam" ?
                        userTeamLoading ? <SmallLoader /> :
                            team &&
                            <>
                                <MyTeam
                                    attackers={team?.filter((dataItem) => dataItem?.position == "Attacker")}
                                    defenders={team?.filter((dataItem) => dataItem?.position == "Defender")}
                                    midfielders={team?.filter((dataItem) => dataItem?.position == "Midfielder")}
                                    goalkeeper={team?.filter((dataItem) => dataItem?.position == "Goalkeeper")}
                                    match_fixture_id={location?.state?.match_fixture_id}
                                />
                                {matchDetails?.match_status == "NS" &&
                                    <div className={classes.edit_button_container}>
                                        <button type='button' className={classes.edit_button}
                                            onClick={() => navigate("/create-fantasy-team", {
                                                state: {
                                                    match_fixture_id: matchDetails?.match_fixture_id,
                                                    edit: true
                                                }
                                            }
                                            )}
                                        >
                                            {t("67")}
                                        </button>
                                    </div>
                                }
                            </>


                        : tab === "events" ? (

                            <div className={classes.grid_col_2}>
                                <MatchEvents
                                    team_name={matchDetails?.home_team_name}
                                    data={matchDetails2?.events?.filter((data) => {
                                        return (
                                            data?.team?.name == matchDetails?.home_team_name &&
                                            data?.type == "Goal" &&
                                            data?.detail != "Missed Penalty"
                                        );
                                    })}
                                />
                                <MatchEvents
                                    team_name={matchDetails?.away_team_name}
                                    data={matchDetails2?.events?.filter((data) => {
                                        return (
                                            data?.team?.name == matchDetails?.away_team_name &&
                                            data?.type == "Goal" &&
                                            data?.detail != "Missed Penalty"
                                        );
                                    })}
                                />
                            </div>

                        ) : tab === "leaderboard" ? leaderboardLoading ? <SmallLoader /> : (
                            <div className={classes.leaderboard_container}>

                                {/* HERE SHOW USER RANK + POINTS... */}

                                <div className={classes.headings}>
                                    <div className={classes.rank_heading}>
                                        {t("68")}
                                    </div>
                                    <div className={classes.number_heading}>
                                        {t("69")}
                                    </div>
                                    <div className={classes.points_heading}>
                                        {t("70")}
                                    </div>
                                </div>
                                {leaderboard?.map((data, index) => {
                                    return (
                                        <div className={classes.leaderboard_data} key={index}>
                                            <div className={classes.rank_data}>
                                                {data?.rank}
                                            </div>
                                            <div className={classes.number_data}>
                                                {data?.msisdn}
                                            </div>
                                            <div className={classes.points_data}>
                                                {data?.total_points}
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        ) : null}

                </Container>
                <PlayerStatsModal matchFixtureId={matchFixtureId} playerId={playerId} playerPointsModal={playerPointsModal} />
            </SubLayout>


        </Layout>
    )
}

export default FantasyGame